// extracted by css-extract-rspack-plugin
export default {"root":"root-1A2SW","closeIcon":"closeIcon-2eErr","image":"image-37Ehi"};